import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { Keepalive, NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SlicePipe } from '@angular/common';
import { DialogComponent } from './pages/shared/dialog/dialog.component';
import { AppLoadingComponent } from './pages/shared/app-loading/app-loading.component';
import { SharedModule } from './pages/shared/shared.module';
import { AlertComponent } from './pages/shared/alert/alert.component';
import { FontSizeComponent } from './pages/shared/font-size/font-size.component';
import { NgBusyModule } from 'ng-busy';
import { DropdownSortPipe } from './pipes/dropdown-sort.pipe';
import { TelephonePipe } from './pipes/telephone.pipe';
import { ScrollTopModule } from 'primeng/scrolltop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RippleModule } from 'primeng/ripple';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TableModule } from 'primeng/table'; 
import { Idle, IdleExpiry, SimpleExpiry } from '@ng-idle/core';

@NgModule({
  declarations: [AppComponent, AppLoadingComponent, AlertComponent],
  imports: [
    BrowserModule,
    TableModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ModalModule.forRoot(),
    SharedModule,
    AlertModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    PopoverModule.forRoot(),
    NgBusyModule,
    ScrollTopModule,
    FormsModule,
    ReactiveFormsModule,
    RippleModule,
    NgScrollbarModule
  ],
  providers: [SlicePipe, TelephonePipe, DropdownSortPipe,Idle,
    Keepalive,
    { provide: IdleExpiry, useClass: SimpleExpiry }], // Ensures independent session per tab],
  bootstrap: [AppComponent],
})
export class AppModule {}
